module.exports = __webpack_public_path__ + "img/27.ad32e006.jpg";